"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.article(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n\n  .arrow {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 40px;\n    width: 40px;\n    border-radius: 20px;\n    margin: 0 8px;\n    color: ", ";\n    background: ", ";\n    border: 1px solid ", ";\n    cursor: pointer;\n    font-size: 22px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n\n  .arrow {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 40px;\n    width: 40px;\n    border-radius: 20px;\n    margin: 0 8px;\n    color: ", ";\n    background: ", ";\n    border: 1px solid ", ";\n    cursor: pointer;\n    font-size: 22px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.light;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map